import angular from 'angular';
import './number.scss';
/**
 * @memberOf cms.input.number
 * @property {object}   bindings.errors         Form errors object
 * @property {string}   bindings.model          Input value reference
 * @property {string}   bindings.title          Input title and/or placeholder
 * @property {string}   bindings.unit           Unit label (if empty, label not added)
 */
let cmsInputNumber = {
    bindings: {
        errors: '=',
        model: '=',
        label: '@',
        units: '=',
        helper: '@',
        onBlur: '&',
        onChange: '&',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@',
        step: '@',
        labelClass: '@'
    },
    template: require('./number.html')
};

/**
 * Number control
 * @namespace cms.input.number
 */
export default angular.module('cms.input.number', []).component('cmsInputNumber', cmsInputNumber).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/NumberControl/CmsInputNumber.js